import { useFormikContext } from "formik";
import { padStart } from "lodash";
import { ICharterRequest } from "../../Models/ICharterRequest";

const FlightTimeSummary = () => {
    const { values } = useFormikContext<ICharterRequest>();
    const totalFlightTime = values.routes.map(r => (r.flightTime ?? "00:00").split(':'))
        .reduce((acc, [hours, minutes]) => acc + parseInt(minutes) + (parseInt(hours) * 60
        ), 0);
    return <><b>Total flight time:</b> {`${padStart(`${Math.floor(totalFlightTime / 60)}`, 2, '0')
        }:${padStart(`${totalFlightTime % 60}`, 2, '0')}`}<br /></>
}

export default FlightTimeSummary;